module.exports = __webpack_public_path__ + "img/ba-payment.84d694e.png";